/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import * as React from 'react'

import { useCarousel } from '@/components/e-commerce/kits/kit-gallery-carousel/Carousel'
import { cn } from '@/utils/css'

type CarouselThumbnailProps = React.HTMLAttributes<HTMLDivElement> & {
  index: number
}

const CarouselThumbnail = React.forwardRef<HTMLDivElement, CarouselThumbnailProps>(
  ({ index, className, children, ...props }, ref) => {
    const { selectedIndex, thumbnailOnClick } = useCarousel()

    return (
      <div
        ref={ref}
        className={cn(
          'relative rounded-2xl overflow-hidden',
          index === selectedIndex && 'border-2 border-blue-500',
          index !== selectedIndex && 'border border-grey-50/20',
          className,
        )}
        onClick={() => thumbnailOnClick(index)}
        {...props}
      >
        {children}
      </div>
    )
  },
)
CarouselThumbnail.displayName = 'CarouselThumbnail'

export { CarouselThumbnail }
